import { getReportEvent } from './utils';
const report = (payload) => {
    const eventKey = getReportEvent('page');
    if (eventKey) {
        const event = new CustomEvent(eventKey, { detail: payload });
        document.dispatchEvent(event);
    }
};
export default report;
